const Error404 = () => import('@client/pages/errorPage/error-404/index.vue');
const Error500 = () => import('@client/pages/errorPage/error-500/index.vue');

export default [
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: Error404 },
  { path: '/500', name: 'serverError', component: Error500 }
];
